import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Button, Grid, IconButton, styled, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete";
import CustomButton from "../CommonComponents/Button";

const ModalHeader = styled("div")({
  fontSize: "20px",
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 9,
  paddingTop: "10px",
  borderBottom: "1px slid red",
});
const ModalBody = styled("div")({
  padding: "15px",
});
export default function ExpenseRejectedModal(props) {
  const {
    title,
    width,
    openModal,
    setOpenModal,
    ApproveAmountHandler,
    remark,
    setRemark,
    isMultiLevelApprover,
  } = props;

  const handleClose = () => setOpenModal(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "50%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    overflow: "hidden",
    // height: "50vh",
    overflow: "auto",
  };

  React.useEffect(() => {
    setRemark("");
  }, [openModal]);

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginLeft: "15px" }}
            >
              {title}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          <ModalBody>
            <Grid
              xs={12}
              container
              direction="row"
              justifyContent="flex-start"
              sx={{ marginTop: "10px" }}
              //</ModalBody> alignItems="center"
            >
              <Grid item xs={2}>
                Remark
              </Grid>
              <Grid item xs={8}>
                <div className="field_box calender">
                  {/* <span>From</span> */}
                  <TextField
                    name="remark"
                    size="small"
                    variant="outlined"
                    value={remark}
                    onChange={(e) => {
                      setRemark(e.target.value);
                    }}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-end"
              // sx={{ marginTop: "250px" }}
              sx={{ marginTop: 5 }}
              spacing={4}
            >
              <Grid item>
                <CustomButton
                  name={"Cancel"}
                  onClick={handleClose}
                  sx={{ margin: "10px" }}
                />
              </Grid>
              <Grid item>
                <Button
                  onClick={ApproveAmountHandler}
                  sx={{
                    padding: "5px 20px",
                    backgroundColor: "crimson",
                    color: "white",
                    ":hover": {
                      backgroundColor: "crimson",
                      color: "black",
                    },
                  }}
                >
                  Reject Amount
                </Button>
              </Grid>
            </Grid>
          </ModalBody>
        </Box>
      </Modal>
    </div>
  );
}
